var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookDoodle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uil:facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.3427 2.35919H3.2213C2.98986 2.35919 2.76789 2.45113 2.60423 2.61479C2.44057 2.77845 2.34863 3.00042 2.34863 3.23186V17.3533C2.34863 17.5847 2.44057 17.8067 2.60423 17.9703C2.76789 18.134 2.98986 18.2259 3.2213 18.2259H10.8215V12.0776H8.75879V9.69756H10.8215V7.91255C10.7787 7.49347 10.8282 7.07013 10.9664 6.6722C11.1046 6.27427 11.3282 5.91139 11.6215 5.60903C11.9148 5.30666 12.2707 5.07212 12.6643 4.92186C13.0578 4.7716 13.4794 4.70925 13.8996 4.7392C14.5171 4.7354 15.1343 4.76719 15.7481 4.8344V6.97641H14.4867C13.4871 6.97641 13.2967 7.45241 13.2967 8.14262V9.67376H15.6767L15.3673 12.0538H13.2967V18.2259H17.3427C17.4573 18.2259 17.5708 18.2034 17.6767 18.1595C17.7825 18.1156 17.8787 18.0514 17.9598 17.9703C18.0408 17.8893 18.1051 17.7931 18.1489 17.6872C18.1928 17.5813 18.2154 17.4679 18.2154 17.3533V3.23186C18.2154 3.11726 18.1928 3.00378 18.1489 2.89791C18.1051 2.79203 18.0408 2.69583 17.9598 2.61479C17.8787 2.53376 17.7825 2.46948 17.6767 2.42562C17.5708 2.38176 17.4573 2.35919 17.3427 2.35919Z",
    fill: "#393939"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookDoodle);
export default __webpack_public_path__ + "static/media/facebookDoodle.2375cf57f1a56cb8d7237ddda3b74a52.svg";
export { ForwardRef as ReactComponent };